"use client";

import Image from "next/image";
import { ComponentProps } from "react";
import { crossDomainImageLoader } from "src/utils/images";
import { isUnifiedTemplatesAPIPreviewImage } from "src/utils/isUnifiedTemplatesImage";

type Props = ComponentProps<typeof Image> & {
  isUnifiedTemplatesPage?: boolean;
};

export const CrossDomainImage = ({
  isUnifiedTemplatesPage,
  ...props
}: Props) => {
  const isUnifiedTemplatesImage =
    isUnifiedTemplatesPage &&
    typeof props.src === "string" &&
    isUnifiedTemplatesAPIPreviewImage(props.src);

  return (
    <Image
      {...props}
      loader={isUnifiedTemplatesImage ? undefined : crossDomainImageLoader}
    />
  );
};
